<div class="modal-header">
     <h5 class="modal-title">Trợ Giúp & Tài Liệu</h5>
    <button type="button" class="close" aria-label="Đóng" (click)="onCancelClick()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div>
        <div [innerHTML]="markdownContent"></div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="onCancelClick()">Đóng</button>
</div>